import React, { useRef } from 'react';

type UseDragAndDropType = {
  files: File[];
  setFiles: (files: File[]) => void;
  setNotification?: (message: string) => void;
};
export const useDragAndDrop = ({
  files,
  setFiles,
  setNotification,
}: UseDragAndDropType) => {
  const fileInput = useRef<HTMLInputElement | null>(null);

  const onDragOver = (e: React.DragEvent) => {
    e.preventDefault();
  };
  const onDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (e?.dataTransfer?.files?.length > 0) {
      handleFiles(e?.dataTransfer?.files);
    }
  };
  const handleFiles = (filesList: FileList) => {
    const validFiles: File[] = [];
    const rejectedFiles: string[] = [];

    for (let i = 0; i < filesList.length; i += 1) {
      const file = filesList[i];

      // Validate file size - reject empty or very small files
      if (file.size === 0 || file.size < 70) {
        rejectedFiles.push(`${file.name} (file too small: ${file.size} bytes)`);
        // eslint-disable-next-line no-continue
        continue;
      }

      // Additional validation: check if file is actually readable
      try {
        const testChunk = file.slice(0, 1);

        if (testChunk.size === 0) {
          rejectedFiles.push(`${file.name} (file appears corrupted)`);
          // eslint-disable-next-line no-continue
          continue;
        }
      } catch (error) {
        rejectedFiles.push(`${file.name} (error reading file)`);
        // eslint-disable-next-line no-continue
        continue;
      }

      validFiles.push(file);
    }

    // Show notification for rejected files
    if (rejectedFiles.length > 0 && setNotification) {
      const rejectedMessage = `Rejected files: ${rejectedFiles.join(', ')}`;

      setNotification(rejectedMessage);
    }

    if (validFiles.length > 0) {
      setFiles([...files, ...validFiles]);
    }
  };

  return { onDragOver, onDrop, handleFiles, fileInput };
};
